import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=5faa22ca&scoped=true"
import script from "./ContactTab.vue?vue&type=script&lang=js"
export * from "./ContactTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa22ca",
  null
  
)

export default component.exports